'use client';

import * as S from './styles.ts';
import { ColorKey } from '@template/theme/types/color.type.ts';
import useLink from '@/lib/helpers/useLink.ts';
import LoadingSpinner from '@template/components/LoadingSpinner';

export interface IButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  variant?: 'flat' | 'solid' | 'outline' | 'light';
  color?: ColorKey;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  children?: any;
  fullWidth?: boolean;
  onClick?: (e?: any) => void;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  loading?: boolean;
  style?: Record<string, any>;
  isIcon?: boolean;
  title?: string;
  navigation?: {
    target?: '_blank' | '_self';
    href?: string;
  };
  href?: string;
  ignoreHref?: boolean;
}

const Button = ({
  variant = 'solid',
  color = 'primary',
  size = 'sm',
  children,
  fullWidth,
  disabled,
  type,
  loading,
  isIcon,
  onClick,
  navigation,
  href,
  ignoreHref,
  ...props
}: IButtonProps) => {
  const link = useLink();
  return (
    <S.Button
      $variant={variant}
      $color={color}
      $size={size}
      $fullWidth={fullWidth}
      $disabled={disabled}
      $isIcon={isIcon}
      onClick={(e) => {
        if (disabled || loading) return;
        if (onClick) {
          onClick(e);
        }
        if ((navigation?.href || href) && !ignoreHref) {
          link({
            href: navigation?.href ? navigation.href : (href as string),
            target: navigation?.target || '_self',
          });
        }
      }}
      type={type}
      {...props}
      // @ts-ignore
      loading={undefined}
    >
      {children}
      {loading && <LoadingSpinner width={16} height={16} />}
    </S.Button>
  );
};

export default Button;
